module.exports = __webpack_public_path__ + "img/withdraw.29984afd.png";